import React from 'react';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';

import { FallbackProps } from 'react-error-boundary';

export const QuizErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
    return (
        <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md mx-auto text-center border-4 border-red-100">
            <div className="w-20 h-20 bg-red-100 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <AlertTriangle size={40} />
            </div>

            <h2 className="text-2xl font-black text-slate-800 mb-2 font-comic text-red-600">
                Quiz System Error
            </h2>

            <p className="text-slate-500 mb-6 bg-slate-50 p-4 rounded-xl font-mono text-sm break-words">
                {error instanceof Error ? error.message : "Unknown error occurred"}
            </p>

            <div className="flex flex-col gap-3">
                <button
                    onClick={resetErrorBoundary}
                    className="w-full py-3 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-xl transition-all flex items-center justify-center gap-2"
                >
                    <RefreshCw size={18} /> Try Again
                </button>
                <button
                    onClick={() => window.location.reload()}
                    className="w-full py-3 bg-slate-100 hover:bg-slate-200 text-slate-600 font-bold rounded-xl transition-all flex items-center justify-center gap-2"
                >
                    <Home size={18} /> Reload App
                </button>
            </div>
        </div>
    );
};
